import intl from 'react-intl-universal';
import { formatTime } from 'utils/formatTime';
import { Button, Tooltip } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import PropTypes from 'prop-types';

export const TotalPaidWageColumn = () => {
  return {
    accessorKey: 'totalPaidWage',
    header: intl.get('paid_wage_label_column_total_paid_wage'),
    enableColumnFilter: false,
    enableSorting: true,
    Cell: totalPaidWageCell,
  };
};

const totalPaidWageCell = ({ renderedCellValue }) => {
  const totalPaidWage = renderedCellValue;
  return <div>￥{totalPaidWage}</div>;
};

totalPaidWageCell.propTypes = {
  renderedCellValue: PropTypes.number.isRequired,
};

export const IssueTitleColumn = () => {
  return {
    accessorKey: 'issueTitle',
    header: intl.get('paid_wage_label_column_issue_title'),
    enableColumnFilter: true,
    enableSorting: false,
  };
};

export const CaseIdColumn = () => {
  return {
    accessorKey: 'caseId',
    header: intl.get('paid_wage_label_column_case_id'),
    enableColumnFilter: true,
    enableSorting: false,
  };
};

export const OrderTimeColumn = () => {
  return {
    accessorKey: 'orderTime',
    header: intl.get('paid_wage_label_column_issue_order_time'),
    enableColumnFilter: true,
    enableSorting: true,
    Cell: ({ renderedCellValue }) => {
      return formatTime(renderedCellValue);
    },
  };
};
export const EmergencyColumn = () => {
  return {
    accessorKey: 'emergency',
    header: intl.get('paid_wage_label_column_emergency'),
    enableColumnFilter: true,
    enableSorting: true,
  };
};

export const CompleteTimeColumn = () => {
  return {
    accessorKey: 'completeTime',
    header: intl.get('paid_wage_label_column_issue_complete_time'),
    enableColumnFilter: true,
    enableSorting: true,
    Cell: ({ renderedCellValue }) => {
      return formatTime(renderedCellValue);
    },
  };
};

export const WageColumn = () => {
  return {
    accessorKey: 'wage',
    header: intl.get('paid_wage_label_column_wage'),
    enableColumnFilter: true,
    enableSorting: true,
    Cell: wageCell,
  };
};

const wageCell = ({ renderedCellValue }) => {
  const { originalWage, currentWage } = renderedCellValue;
  if (currentWage === null || currentWage === originalWage) {
    return (
      <div>
        <p>￥{originalWage}</p>
      </div>
    );
  }
  return (
    <div>
      <p>
        ￥{currentWage} <del>￥{originalWage}</del>
      </p>
    </div>
  );
};

wageCell.propTypes = {
  renderedCellValue: PropTypes.shape({
    originalWage: PropTypes.number.isRequired,
    currentWage: PropTypes.number.isRequired,
  }).isRequired,
};

export const ViewColumn = (goToIssueDetails) => {
  return {
    accessorKey: 'view',
    header: intl.get('paid_wage_label_column_view_issue'),
    enableColumnFilter: false,
    enableSorting: false,
    enableColumnActions: false,
    muiTableBodyCellProps: {
      onClick: (e) => e.stopPropagation(),
    },
    Cell: ({ renderedCellValue }) => {
      return viewCell({ renderedCellValue, goToIssueDetails });
    },
  };
};

const viewCell = ({ renderedCellValue, goToIssueDetails }) => {
  const issueId = parseInt(renderedCellValue.issueId);
  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={() => goToIssueDetails(issueId)}>
        {intl.get('paid_wage_button_view_issue')}
      </Button>
    </div>
  );
};

viewCell.propTypes = {
  renderedCellValue: PropTypes.shape({
    issueId: PropTypes.string.isRequired,
  }).isRequired,
  goToIssueDetails: PropTypes.func.isRequired,
};

export const FlagColumn = () => {
  return {
    accessorKey: 'flag',
    header: intl.get('paid_wage_label_column_flag'),
    enableColumnFilter: false,
    enableSorting: false,
    enableColumnActions: false,
    Cell: flagCell,
  };
};

const flagCell = ({ renderedCellValue }) => {
  const ifStarred = renderedCellValue;
  return (
    <div>
      {ifStarred && (
        <Tooltip title={intl.get('paid_wage_detailed_tooltip_star_mark')}>
          <StarIcon fontSize="large" color="warning" />
        </Tooltip>
      )}
    </div>
  );
};

flagCell.propTypes = {
  renderedCellValue: PropTypes.bool.isRequired,
};
